import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  TransitionChild,
} from "@headlessui/react";

import { ROUTES } from "~/router";
import { usePermissions } from "~/screens";
import { customIcons, icons } from "~/ui";
import { AdminMobileNavFooter } from "./admin-mobile-nav-footer";
import { AdminMobileNavItem } from "./admin-mobile-nav-item";

interface AdminMobileNavProps {
  open: boolean;
  onClose: () => void;
}

export const AdminMobileNav = ({ open, onClose }: AdminMobileNavProps) => {
  const {
    canViewProviderSchedule,
    canViewBanners,
    canManageInsuranceProviders,
    canViewUserEvents,
  } = usePermissions();

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50 lg:hidden">
      <DialogBackdrop
        transition
        className="data-closed:opacity-0 fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear"
      />
      <div className="fixed inset-0 flex">
        <DialogPanel
          transition
          className="data-closed:-translate-x-full relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out"
        >
          <TransitionChild>
            <div className="data-closed:opacity-0 absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out">
              <button type="button" onClick={onClose} className="-m-2.5 p-2.5">
                <span className="sr-only">Close sidebar</span>
                <icons.outline.XMarkIcon
                  aria-hidden="true"
                  className="size-6 text-white"
                />
              </button>
            </div>
          </TransitionChild>

          <div className="flex grow flex-col overflow-y-auto bg-white">
            <div className="h-18 border-blueGrey flex shrink-0 items-center border-b px-6">
              <customIcons.LogoIcon className="w-44" />
            </div>

            <nav className="flex flex-1 flex-col gap-y-1 px-4 py-6">
              <AdminMobileNavItem
                path={ROUTES.dashboard}
                title="User Dashboard"
                onClose={onClose}
              />
              {canViewUserEvents && (
                <AdminMobileNavItem
                  path={ROUTES.adminUserEvents}
                  title="User Events"
                  onClose={onClose}
                />
              )}
              {canViewProviderSchedule && (
                <AdminMobileNavItem
                  path={ROUTES.adminProviderDashboard}
                  title="Clinician Dashboard"
                  onClose={onClose}
                />
              )}
              {canViewBanners && (
                <AdminMobileNavItem
                  path={ROUTES.adminBannerManagement}
                  title="Banner Management"
                  onClose={onClose}
                />
              )}
              {canManageInsuranceProviders && (
                <AdminMobileNavItem
                  path={ROUTES.adminInsuranceProviders}
                  title="Insurance Providers"
                  onClose={onClose}
                />
              )}
            </nav>

            <AdminMobileNavFooter />
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
